import { makeEpisodeRoutes } from "@/routes/episodeRoutes"

export default makeEpisodeRoutes({
  listName: "episodes",
  createName: "episodes.create",
  detailName: "episode",
  editName: "episode.edit",
  parent: "podcasts",
})
